module.exports = __webpack_public_path__ + "static/media/img_step_3.977eba78.jpg";